import React, { useEffect, useState } from 'react';
import '../../css/steps.css';
import Preloader from '../../Components/Preloader';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { NavLink } from 'react-router-dom';
import Finish_Seo from '../../SEO/Finish_Seo';

function Finish() {
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        // Simulate an asynchronous operation (e.g., fetching data)
        setTimeout(() => {
            setIsLoading(false);
        }, 500); // Simulating a 1-second delay
    }, []);
    return (
        <>
            {isLoading ? (
                <Preloader />
            ) : (
                <>
                    <Finish_Seo />
                    <Header />
                    {/* Internal CSS */}
                    <style>
                        {`
                            .cardcss {
                                    box-shadow: 0 5px 40px 0 rgba(0,0,0,.11);
                                    margin: 0 0 20px 0
                                }
                        `}
                    </style>
                    {/* Start Page Banner Area */}
                    <div className="page-banner-area position-relative overflow-hidden" style={{ backgroundImage: 'url(assets/images/hero/hero-image-2.svg)' }}>
                        <div className="container">
                            <div className="page-banner-content">
                                <h1>Onboarding</h1>
                                <ul>
                                    <li><NavLink to="/help">Help</NavLink></li>
                                    <li>KYC Upload</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* End Page Banner Area */}
                    {/* Onboarding section start */}
                    <div className="ptb-100">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
                                    <div className="card px-0 pb-0 mb-3">
                                        <h2 id="heading">KYC Documents Upload</h2>
                                        <p className="mt-2">On our mobile app to complete your onboarding process we require your Photo ID and a selfie. We use ID Scan solution which takes less than a minute to complete this for you. </p>
                                        <div id="msform">
                                            {/* progressbar */}
                                            <ul id="progressbar">
                                                <NavLink to="/onboarding">
                                                    <li className="active" id="confirm"><strong>1) Scanning Your Id</strong></li>
                                                </NavLink>
                                                <NavLink to="/livenesscheck">
                                                    <li className="active" id="confirm"><strong>2) Liveness Check</strong></li>
                                                </NavLink>
                                                <NavLink to="/finish">
                                                    <li className="active" id="confirm"><strong>Finish</strong></li>
                                                </NavLink>
                                            </ul>
                                            {/* fieldsets */}
                                            <fieldset>
                                                <div className="form-card">
                                                    <div className="row justify-content-center">
                                                        <div className="col-12 col-md-4 col-lg-4">
                                                            <div className="card cardcss">
                                                                <img className="card-img-top" src="assets/images/photo/finishimg.png" alt="Finish Image" />
                                                                <div className="card-body">
                                                                    <p className="card-text">On completion of your IDScan and Liveness check you will get a success screen to confirm completion of onboarding.</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row justify-content-center">
                                                        <div className="col-12 text-center">
                                                            <h5 className="purple-text text-center">If you have any further questions then please visit our Onboarding FAQs page.</h5>
                                                        </div>
                                                        <NavLink to="/onboarding-faq" className="next action-button text-center">FAQs</NavLink>
                                                    </div>
                                                </div>
                                            </fieldset>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Onboarding section end */}
                    {/* Footer Section Here */}
                    <Footer />
                </>
            )}
        </>
    );
}

export default Finish
